var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSanta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 392.65042,
    height: 794.00055,
    viewBox: "0 0 392.65042 794.00055",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608.26334,71.81116a25.13992,25.13992,0,0,0-25,28.3,24.821,24.821,0,0,0,2.82,8.7,25.63543,25.63543,0,0,0,1.69,2.75,25.2,25.2,0,0,0,31.42,8,22.14013,22.14013,0,0,0,2.48-1.38,25.16,25.16,0,0,0-13.41-46.37Zm0,21.39a7.55,7.55,0,1,1,7.55-7.55v0A7.55,7.55,0,0,1,608.26334,93.20116Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeeff0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M588.13333,83.13116l-.36,28.47a25.63455,25.63455,0,0,1-1.69-2.79Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.10336,83.13116l-.43,35.14a22.14013,22.14013,0,0,1-2.48,1.38Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.26334,100.11116a25.17,25.17,0,0,1-49.94,0A58,58,0,0,1,633.26334,100.11116Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M666.14334,154.86116a58.26929,58.26929,0,0,1-1.41,12.75,57.28051,57.28051,0,0,1-9.47,21,59.591,59.591,0,0,1-5,6,57.81007,57.81007,0,0,1-29.28,16.66,51.56932,51.56932,0,0,1-6.11,1,53.83028,53.83028,0,0,1-6.64.39,57.8203,57.8203,0,0,1-21.19-4,53.42847,53.42847,0,0,1-5.65-2.58,58.06,58.06,0,0,1-27.9-32.44,54.72668,54.72668,0,0,1-1.73-6.11c-.36-1.59-.65-3.2-.87-4.84a59.00608,59.00608,0,0,1-.54-7.91,57.90076,57.90076,0,0,1,2.51-16.91c.33-1.11.71-2.2,1.11-3.29a57.89,57.89,0,0,1,102.09-12.35h0A57.61965,57.61965,0,0,1,666.14334,154.86116Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeeff0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.00333,134.66116l-.48,39.06a54.72668,54.72668,0,0,1-1.73-6.11c-.36-1.59-.65-3.2-.87-4.84l2-24.82C553.26334,136.81116,553.60336,135.75116,554.00333,134.66116Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.13333,122.14116l-1.06,86.6a53.43117,53.43117,0,0,1-5.65-2.58Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.10336,122.14116l-1.09,89.19a51.56727,51.56727,0,0,1-6.11,1Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.08334,122.14116v.1l-.82,66.42a59.59457,59.59457,0,0,1-5,6l5.77-72.44Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.73331,167.61116a57.89,57.89,0,0,1-112.94,0A112.05,112.05,0,0,1,664.73331,167.61116Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M720.26334,266.81116a111.49022,111.49022,0,0,1-27.68,73.71c-2.36,2.68-4.82,5.25-7.41,7.69a111.55957,111.55957,0,0,1-47,26.55c-2.89.82-5.85,1.5-8.83,2.05a112.48,112.48,0,0,1-45.29-.65c-2.92-.63-5.8-1.4-8.63-2.27a111.69988,111.69988,0,0,1-45.2-26.82c-2.39-2.29-4.67-4.72-6.83-7.25-40.36246-46.87241,19.5447-134.48545,11.78735-157.95271s117.59021-35.08509,157.9527,11.78732A112,112,0,0,1,720.26334,266.81116Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeb808"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "118.27 275.3 119.58 134.64 111.44 268.05 118.27 275.3",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.60336,206.45116l-1.59,169.75c-2.92-.63-5.8-1.4-8.63-2.27Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.71335,206.45116l-1.58,168.36c-2.89.82-5.85,1.5-8.83,2.05Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.66 268.75 281.9 134.64 273.24 276.44 280.66 268.75",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M608.26335,298.31116c104.10307,4.68787,181.50771,41.85584,173.65,176.79-5.67621,97.4733-77.74576,176.79-173.65,176.79s-167.99277-79.31562-173.65-176.79C425.8307,323.77521,510.67613,293.91669,608.26335,298.31116Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeeff0"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "69.26 315.84 52.9 520.95 66.75 520.95 69.26 315.84",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.16 315.84 76.8 520.95 90.65 520.95 93.16 315.84",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.34 315.84 291.98 520.95 305.83 520.95 308.34 315.84",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.24 315.84 315.88 520.95 329.73 520.95 332.24 315.84",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.07333,548.97113c-27.47,60.76-87.81,102.93006-157.81,102.93006s-130.34-42.17005-157.81-102.93006C514.95837,461.81507,637.904,443.45279,725.06,507.95786A196.32908,196.32908,0,0,1,766.07333,548.97113Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M804.56332,669.51117a195.46991,195.46991,0,0,1-51,132q-5.35,5.93-11.22,11.4a196.501,196.501,0,0,1-43.28,30.71q-6.39,3.36-13.08,6.24a194.78211,194.78211,0,0,1-41.2,12.59q-6.84,1.29-13.82,2.09a195.77627,195.77627,0,0,1-22.7,1.2699q-8.91,0-17.6-.78c-4.62-.42-9.2-1-13.72-1.71a193.83082,193.83082,0,0,1-40.28-11q-6.52-2.50992-12.82-5.51a195.57022,195.57022,0,0,1-41-26.25q-5.66-4.67989-10.93-9.79a195.58009,195.58009,0,0,1-60-141.22q0-8.91.78-17.61c4.92563-167.58984,95.6199-184.07538,195.52-178.69,111.26709,5.99814,195.57489-2.14172,195.52,178.69Q804.55329,660.60114,804.56332,669.51117Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeb808"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M484.93335,597.81116l-2.07,222.71q-5.66-4.68-10.93-9.79Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.04337,597.81116l-2.38,254.52q-6.52-2.52-12.82-5.52Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.74 793.22 181.24 525.98 165.03 791.51 178.74 793.22",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.88 790.6 235.34 525.98 219.06 792.69 232.88 790.6",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.36331,597.81116l-2.29,245.79q-6.39,3.36-13.08,6.24Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.47336,597.81116l-1.9,203.68q-5.35,5.93-11.22,11.4Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.96335,372.55115c0,57-47.32,103.18-105.7,103.18s-105.7-46.19-105.7-103.18a101.19072,101.19072,0,0,1,3.91-27.89c10.4-36.27,40.6-64.47,78.52-72.78a109.12,109.12,0,0,1,46.54,0c37.92,8.31,68.12,36.51,78.52,72.78A101.19075,101.19075,0,0,1,713.96335,372.55115Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M711.44333,370.03116a103,103,0,1,1-3.81-27.88A103,103,0,0,1,711.44333,370.03116Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#ffab9e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M511.37335,266.85117c64.21649-59.56073,128.80823-59.81142,193.78,0a15.1,15.1,0,0,1,15.1,15.1v42.78a15.1,15.1,0,0,1-15.1,15.1c-63.28365-29.58356-127.67415-34.16486-193.78,0a15.1,15.1,0,0,1-15.1-15.1v-42.78A15.1,15.1,0,0,1,511.37335,266.85117Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeeff0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M735.35336,512.22113c0,32.65-17.98,45.55-41.64,57.86005q-3.855,1.99494-7.89,4c-8.43,4.23-17.36,8.62-26.31,13.94995-3.08,1.84-6.17,3.78-9.24,5.87006a136.462,136.462,0,0,0-25.07,21.71,129.27019,129.27019,0,0,0-11.86,15.39l-.01.02c-1.74,2.64-3.43,5.38-5.07,8.29-44.04,78.02-127.09-56.9-127.09-127.09a127.09,127.09,0,0,1,254.18,0Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#eeeff0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M629,434.34827c0,3.88687-9.28506,11.82942-20.73666,11.82942s-20.73667-7.94256-20.73667-11.82942,9.28506-2.259,20.73667-2.259S629,430.45738,629,434.34827Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#ffab9e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M804.56332,667.00116a196.42739,196.42739,0,0,1-5.25,45.29h-382.05a196.429,196.429,0,0,1-5.25-45.29q0-8.91.78-17.62h391Q804.55326,658.08125,804.56332,667.00116Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.56332,672.03113a196.58129,196.58129,0,0,1-5.25,45.3h-382.05a196.57965,196.57965,0,0,1-5.25-45.3q0-8.91.78-17.62h391Q804.55326,663.11111,804.56332,672.03113Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M804.56332,669.51117a196.51026,196.51026,0,0,1-5.25,45.3h-382.05a196.51026,196.51026,0,0,1-5.25-45.3q0-8.91.78-17.61c135.59265-24.91651,268.55456-37.36988,391.00006,0Q804.55328,660.6011,804.56332,669.51117Z",
    transform: "translate(-411.91319 -71.81109)",
    fill: "#373e46"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 196.35016,
    cy: 611.54005,
    r: 44.03999,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.35016,
    cy: 611.54005,
    r: 41.52001,
    fill: "#eeeff0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.35016,
    cy: 611.54005,
    r: 32.72002,
    fill: "#373e46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.20334,458.11115l-1.81,148.7a127.21382,127.21382,0,0,1-9.32-9.26Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.17331,458.11115l-2.07,170.47a116.78559,116.78559,0,0,1-11.08-5.54Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.15335,458.11115l-2.2,180a120.54412,120.54412,0,0,1-12-2.23Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.12332,458.11115l-1.92,157.5a129.27019,129.27019,0,0,0-11.86,15.39Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.10336,458.11115l-1.59,129.92c-3.08,1.84-6.17,3.78-9.24,5.87006Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.07333,458.11115l-1.36,111.97q-3.855,1.99494-7.89,4Z",
    transform: "translate(-411.91319 -71.81109)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.66 243.02 119.58 195.21 119.14 243.02 116.66 243.02",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.24 243.02 173.69 195.21 170.77 243.02 173.24 243.02",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.79 195.21 227.34 243.02 224.87 243.02 227.79 195.21",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.98 243.02 281.9 195.21 281.46 243.02 278.98 243.02",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.5302,
    cy: 317.16008,
    r: 36.55661,
    fill: "#ffab9e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanta);
export default __webpack_public_path__ + "static/media/santa.ec1b681666e5619632b2e9164f44ffc4.svg";
export { ForwardRef as ReactComponent };